import styled from 'styled-components';

export default function GenderSelectBox(props) {
  const { value, setValue } = props;

  return (
    <Wrapper>
      <GenderButton $isSelected={value === 'Male'} onClick={() => setValue('Male')}>
        <ButtonText $isSelected={value === 'Male'}>Male</ButtonText>
      </GenderButton>
      <GenderButton $isSelected={value === 'Female'} onClick={() => setValue('Female')}>
        <ButtonText $isSelected={value === 'Female'}>Female</ButtonText>
      </GenderButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  gap: 5px;

  width: 128px;
  height: 32px;
`;

const GenderButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 7px 0;

  height: 32px;

  background: ${props => props.$isSelected ? props.theme.primary : props.theme.subBackground};
  border: 1px solid ${props => props.$isSelected ? props.theme.primary : props.theme.line};
  border-radius: 5px;

  box-sizing: border-box;
  flex: 1;
  cursor: pointer;

  transition: all 0.3s ease-in-out;
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 17px;
  text-align: center;

  color: ${props => props.$isSelected ? props.theme.white : props.theme.subText};

  margin: 0;

  transition: all 0.3s ease-in-out;
`;
